import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {HttpClient} from '@angular/common/http';
import {MatchingHistory} from '../shared/matching-history';
import {environment} from '../../environments/environment';

@Injectable()
export class HistoryService {

  constructor( private http: HttpClient ) { }
  musicPointUrl: string = environment.dashboardApiUrl;
  radioFuseUrl: string = environment.dashboardApiUrl;

  getMatchHistoryCcidList(): Observable<Array<string>> {
    const musicPointUrl = this.musicPointUrl + '/play/history';
    return this.http.get<Array<string>>(musicPointUrl);
  }

  getMatchingHistory(ccidList: string[]): Observable<Array<MatchingHistory>> {
    if (ccidList.length > 0) {
      const radioFuseUrl = this.radioFuseUrl + '/match/' + ccidList.join(',');
      return this.http.get<Array<MatchingHistory>>(radioFuseUrl);
    }
    return null;
  }


  getOriginalMetaData(ccid): Observable<MatchingHistory> {
    const musicPointUrl = this.musicPointUrl + '/play/match/originalMetaData/'  + ccid;
    return this.http.get<MatchingHistory>(musicPointUrl);
  }

  undoMatchRadioFuse(history: MatchingHistory): Observable<boolean> {
    const radioFuseUrl = this.radioFuseUrl + '/match' ;
    return this.http.request<boolean>('DELETE', radioFuseUrl, { body: history});
  }

  undoDataStewardMatch(ccid: number): Observable<boolean> {
    const musicPointUrl = this.musicPointUrl + '/play/match/'  + ccid;
    return this.http.delete<boolean>(musicPointUrl);

  }

}



// WEBPACK FOOTER //
// ./src/app/history/history.service.ts